import React from 'react';
import Input from './Input';

type Props = {
    placeholder?: string,
    defaultValue?: any,
    onChange?: any,
    max?: number,
    min?: number,
}

const NumberInput = (props: Props) => {
    return (
        <Input type="number" { ...props } />
    )
}

export default NumberInput;